/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DisplayPromoCode_user$ref = any;
export type DisplayPromoCode_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": DisplayPromoCode_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DisplayPromoCode_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currency",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'db9d5299d9bc94ea67624417efdaa24c';
export default node;
